export const arrayToSentence = (words: string[]): string => {
  if (words.length === 1) return words[0];
  const lastWord = words.at(-1);
  const theRest = words.slice(0, -1);

  return [ theRest.join(", "), lastWord ].join(" and ");
};
